import get from 'lodash/get';
import DataGrid2 from '../../..';

export function getRowValues(this: DataGrid2, rowIndex: number) {
	return get(this.rows, [rowIndex, 'data']);
}
